import { FC, ReactNode } from "react";
import { createPortal } from "react-dom";

interface Props {
  children: ReactNode;
}

// Выносит модалку в body: внутри другой модалки (transform у .modal-content)
// position: fixed считается от родителя и модалка обрезается.
export const Portal: FC<Props> = ({ children }) =>
  createPortal(children, document.body);
